<template>
<div class='model'>
    <div class="model_box" v-if="!store"
     @click="showmodel">录入高考成绩<i class="el-icon-edit" style="padding-left: 10px;"></i></div>
     <!-- sorry写的和屎一样这一坨,改了无数次,自己做ui,屎上加屎 -->
    <div class="model_box1" v-else>
       分数:{{form1.km}} 
       <span class="noshowpp"> 
        (<p style="margin-top: 15px;display: inline-block;font-size: 13px;" v-if="store">分数对应 <span style="color: #409EFF;">{{form1.km3||'???'}}</span > 年排名区间为 <span style="color: #409EFF;">{{form1.km2||'???'}}</span> 名</p>)</span>
        <span style="color: #80808080;padding: 0px 6px;">|</span> {{  form1.km4=='理科'?'物理':'历史'  }} {{ form1.km1 }}
        <span style="padding-left: 10px;"> ({{ form1.km4 }})</span>
        <i class="el-icon-edit"   @click="showmodel" style="padding-left: 10px;color: rgb(64, 158, 255);"></i>
        <img src="@/assets/3c47346c64cb1a3265043459b8203d5.png" alt="" style="display: inline-block;width: 40px;height: 40px;border-radius: 40px;margin-left: 15px;">
    </div>
    <p class="showp" style="margin-top: 1px;display: none;font-size: 13px;" v-if="store">分数对应 <span style="color: white;">{{form1.km3||'???'}}</span > 年排名区间为 <span style="color: white;">{{form1.km2||'???'}}</span> 名</p>
    <el-dialog
    title="录入高考成绩"
    :visible.sync="dialogVisible"
    width="600px"
    custom-class="zhaoge"
    :before-close="handleClose">
      <!-- 表单啊，该死 -->
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="首选科目" prop="km"  >
            <el-radio-group v-model="form.km" >
                <el-radio border :label="'理科'">物理</el-radio>
                <el-radio border :label="'文科'">历史</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="次选科目" prop="km1"
        :rules="[{ required: true, message: '请选择科目', trigger: 'blur' },
            { validator: validateOptions1, trigger: 'blur' }]">
            <el-checkbox-group
                class="group"
                v-model="form.km1"
                :min="0"
                :max="2"
                >
                <el-checkbox border label="生物">生物</el-checkbox>
                <el-checkbox border label="化学">化学</el-checkbox>
                <el-checkbox border label="地理">地理</el-checkbox>
                <el-checkbox border label="政治">政治</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <div class="flex_form">
            <el-form-item label="我的成绩" prop="km2"
            :rules="{ required: true, message: '请输入成绩', trigger: 'blur' }"
            >
                <!-- <el-input v-model.trim="form.zkfx" prefix-icon="el-icon-edit" clearable/> -->
                <el-input-number
                    class="input_number"
                    style="width: 200px;"
                    size="small"
                    v-model.trim="form.km2"
                    @blur="handleInput"
                    type="number"
                    :min="100"
                    :max="750"
                />
            </el-form-item>
            <el-form-item label="我的位次" prop="km3" >
                <!-- <el-input v-model.trim="form.zkfx" prefix-icon="el-icon-edit" clearable/> -->
                <el-input-number
                    class="input_number"
                    style="width: 200px;"
                      size="small"
                    v-model.trim="form.km3"
                    type="number"
                >
            </el-input-number>
            <p style="
                position: absolute;
                top: 25px;
                width: 266px;
                left: -69px;
                line-height: 20px;font-size: 12px;">
                分数对应 <span style="color: #409EFF;">{{form.km5||'???'}}</span > 年排名区间为 <span style="color: #409EFF;">{{form.km4||'???'}}</span> 名
            </p>
            </el-form-item>
            <span></span>

        </div>
        <div class="button_box" @click="saveMassage">保存信息</div>
    </el-form>

    </el-dialog>
</div>
</template>

<script>
  import axios from "axios";
const validateOptions = (rule, value, callback) => {
    if (value.length < 2) {
        callback(new Error('请至少选择两个选项'));
    } else {
        callback();
    }
};
export default {
name: 'model',
    data() {
        return {
            dialogVisible: false,
            km1: [],
            validateOptions1:validateOptions,
            form: {
                km: '理科',
                km1: [],
                km2: undefined,
                km3: undefined,
                km4: '',
                km5: '',
            },
            // 获取显示值
            form1: {
                km: '',
                km1:'',
                km2: '',
                km3:'',
            },
            store:false
        };
    },
components: {},
computed:{},
watch: {},
    created() {
        if (localStorage.getItem('km')) {
            this.form = JSON.parse(localStorage.getItem('km'))
            // console.log(  this.form ,"  this.form ");
            this.form1.km4=this.form.km
            this.form1.km = this.form.km2
            this.form1.km2 = this.form.km4
            this.form1.km3 = this.form.km5
            this.form1.km1=this.form.km1.join('')
            this.store=true
        } else {
            this.store=false 
        }
    },
activated() {},
    methods: {
        handleInput() {
            var apiUrl='/cjfxapi/Records/GetWcqjByScore'
            axios
            .get(apiUrl, {
                params: {
                    type: this.form.km,
                    score:this.form.km2,
                },
            }).then(res => {
                if (res.data.data.length == 0) {
                    
                } else {
                    this.form.km3 = res.data.data[0].WCQJ.split('-')[1]
                    this.form.km4 = res.data.data[0].WCQJ
                    this.form.km5=res.data.data[0].YEAR
                }  
            })
        },
        // 保存信息到本地存储，；垃圾代码
        saveMassage() {
            this.$refs['form'].validate((valid) => {
            if (valid) {
                localStorage.setItem('km', JSON.stringify(this.form));
                this.form = JSON.parse(localStorage.getItem('km'))
                this.form1.km = this.form.km2
                this.form1.km1 = this.form.km1.join('')
                this.form1.km2 = this.form.km4
                this.form1.km3 = this.form.km5
                this.form1.km4=this.form.km
                this.dialogVisible = false
                this.store=true
            } else {

                return false;
            }
            });
        },
        showmodel() {
            this.dialogVisible = true;
        },
        handleClose(done) {
            done();
        }
    },
}
</script>

<style lang='scss'>
    .model{
        .zhaoge{
            margin-top: 29vh !important;
            background-image: linear-gradient(to bottom, rgb(23 150 244 / 25%), #FFFFFF);
            width: 600px;
            border-radius: 20px;
            .el-dialog__header{
                font-weight: bold;
            }
            .el-dialog__body{
                padding-top: 10px;
            }
        }
        width: 691px;
        position: relative;
        top: -180px;
        left: 34%;
        .model_box{
            width: 266px;
            height: 44px;
            background: linear-gradient(133deg, #60a8eb, #056ad2);
            border-radius: 8px;
            text-align: center;
            line-height: 44px;
            font-size: 16px;
            cursor: pointer;
            font-weight: 500;
            color: #fff;
            position: relative;
            left: 22%;
            overflow: hidden;
        }
        .model_box1{
            width: 100%;
            height: 44px;
            display: flex;
            align-items: center;
            // background: linear-gradient(133deg, #ff9b4c, #f60);
            border-radius: 8px;
            text-align: center;
            line-height: 44px;
            font-size: 17px;
            cursor: pointer;
            font-weight: 500;
            color: black;
            position: relative;
            overflow: hidden;
        }
        .el-form-item{
            .el-form-item__content{
                .el-checkbox__input{
                    display: none !important;
                }
                .el-radio{
                    margin-right: 10px;
                    padding-left: 20px;
                    padding-right: 31px;
                    border-radius: 11px;
                }
            }
            .group{
                .el-checkbox{
                    margin-right: 10px;
                    padding-left: 20px;
                    padding-right: 31px;
                    border-radius: 11px;
                }
            }
            .is-checked{
                // border-color: rgba(255, 102, 0, 0.968627451);
                .el-radio__label{
                    // color:rgba(255, 102, 0, 0.968627451);
                }
                .el-checkbox__label{
                    // color:rgba(255, 102, 0, 0.968627451);
                }
            }
        }
        .flex_form{
            display: flex;
            justify-content: space-between;
            align-items: center;
            // .el-form-item{
            //     margin-right: 0;
            // }
            .input_number{
                .el-input-number__decrease{
                display: none;
                }
                .el-input-number__increase{
                display: none;
                }
                input{
                text-align: left;
                padding-left: 10px;
                }
            }
        }
        .button_box{
            user-select: none;
            cursor: pointer;
            width: 50%;
            margin: 0 auto;
            height: 44px;
            background: linear-gradient(133deg, #4cc4ffd9, #004cffbd);
            border-radius: 8px;
            text-align: center;
            line-height: 44px;
            font-size: 16px;
            font-weight: 500;
            color: #fff;
            position: relative;
            margin-top: 20px;
        }
    }
    // 手机端样式调整
    @media screen and (max-width: 600px) {
        .model{
            position: inherit;
            width: 100%;
            padding: 10px;
            // background: linear-gradient(133deg, #ff9b4c, #f60);
            background: linear-gradient(133deg, #60a8eb, #056ad2);
            .model_box{
                background: none !important;
                left: 14% !important;
            }
            .zhaoge{
                margin-top: 15vh !important;
                width: 90% !important;
                .el-dialog__body{
                    padding: 17px 3px;
                }
                .el-form{
                    display: block !important;
                    .el-form-item{
                    .el-form-item__content{
                        .el-radio{
                            margin-left: 0px;
                            padding-left: 11px;
                            padding-right: 21px;
                        }
                    }
                    .group{
                        .el-checkbox{
                            margin-left: 0px;
                            padding-left: 13px;
                            padding-right: 23px;
                        }
                    }
                   }
                   .flex_form{
                    display: block !important;
                   }
                }
            }
        }
        .model_box1{
            justify-content: center;
            // right:27px;
            .noshowpp{
              display: none  !important;
            }
          i{
            color: white !important;
          }
        }
        .showp{
            display: block !important;
            padding-left: 22px;
        }
    }

</style>